//*** Lib */

import {
    createCookie, getCookie, isCookieExist, removeAllCookies,
    setCookie
} from "../../utils/index.jsx";
import { AUTH_BASE_URL } from "../api/helper/environment/EnvironmentConfig";


const authCookieName = 'AuthUser';
const tokenCookieName = 'Token';
const ERP_AUTH_USER_COOKIE = 'ErpAuthUser';

export const setAuthProps = (data) => {
    const authProps = {
        cookieName: authCookieName,
        cookieValue: data,
        expirationTime: data?.sessionTimeout
    }
    createCookie(authProps);
    setTokenProps(data.token);
};
export const getAuthProps = () => {
    return getCookie(authCookieName);
};

export const getErpAuthProps = () => {
    return getCookie(ERP_AUTH_USER_COOKIE);
};

export const isAuthorized = () => {
    return isCookieExist(authCookieName);
};
export const setTokenProps = (data) => {
    const tokenProps = {
        cookieName: tokenCookieName,
        cookieValue: data
    }
    setCookie(tokenProps);
};
export const getTokenProps = () => {
    return getCookie(tokenCookieName);
};
export const signOut = (redirectUrl = `${AUTH_BASE_URL}/login`) => {
    removeAllCookies();
    localStorage.clear();
    window.location.href = redirectUrl;
};
export const signOutErp = () => {
    removeAllCookies();
    localStorage.clear();

    const erpDomains = ['.gujgov.edu.in', 'testhrms.gujgov.edu.in', 'gujgov.edu.in'];
    const erpCookies = ['JSESSIONID', '_ga', '_gid', '_gat_gtag_UA_180317260_1'];

    erpCookies.forEach(cookieName => {
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        erpDomains.forEach(domain => {
            document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
        });
    });

    window.location.href = "https://testhrms.gujgov.edu.in/index.jsp";
};
export const handleRefreshAuthProps = (data) => {
    const cookie = getCookie(authCookieName);
    let modifyCookie = {
        ...cookie,
        token: data.token
    }
    const authProps = {
        cookieName: authCookieName,
        cookieValue: modifyCookie,
        expirationTime: Number(data.sessionTimeout)
    }
    createCookie(authProps);
    setTokenProps(data.token);
};
